export default __webpack_public_path__ + "fonts/tpl_2.445ac13e6d9e0aa7185982357c984f02.png";